<div class="reddi-response-button-container">
  <button
    mat-button
    type="button"
    (click)="onClick.emit()"
    [ngClass]="_buttonClasses"
  >
    {{ _displayText }}
  </button>
</div>
